import React, { useEffect, useState } from "react";
import { Formik, Form, FieldArray, ErrorMessage } from "formik";
import { useDropzone } from "react-dropzone";
import * as Yup from "yup";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import FieldInput from "../../../../CustomComponents/FieldInput";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import { fireStore } from "../../../../../Firebase/config";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import { urtoast } from "../../../../Layouts/CustomPopup/eventEmitter";
import LoginLoaderButton from "../../../../Common/Loader/LoginLoaderButton";
import { disabledStyle } from "../../../../Common/ClickDisable";
import { urlValidation } from "../../../../../CloudStorage/CommonFunction";
import pdficon from "../../../../Common/FilesRelevent/pdf.png";
import { titlevalidation } from "../../../../Common/commonvalidation";
import useFileValidator from "../../../../../hooks/useFileValidator";
import UploadLoader from "../../../../Common/Loader/UploadLoader";

const bxpDatatomap = [
  { title: "Project title", name: "title", placeholder: "Enter title" },
  {
    title: "Upload file*  ",
    name: "files",
    placeholder: "Drag and drop or Browse file",
  },
  { title: "Project URL", name: "url", placeholder: "Type URL " },
];

const validationSchema = Yup.object().shape({
  work_samples: Yup.array()
    .of(
      Yup.object().shape({
        title: titlevalidation,
        url: Yup.string()
          .test("valid-url", "Enter a valid URL", (value) =>
            urlValidation(value),
          )
          .required("URL is required"),
        files: Yup.array()
          .of(
            Yup.object().shape({
              file: Yup.mixed().required("File is required"),
            }),
          )
          .required("Files are required")
          .min(1, "At least one file is required"),
      }),
    )
    .required("Must have work samples")
    .min(1, "Minimum of 1 work sample"),
});

const WorkSamples = ({ updateindex, bxpData, setbxpData, setActiveTab }) => {
  const [loading, setLoading] = useState(null);

  const initialValues = {
    work_samples: bxpData?.work_samples || [
      {
        title: "",
        url: "",
        files: "",
      },
    ],
  };

  const path = "Assets/scss/FirstTimeUsers.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const uploadFileToFirebase = (file) => {
    return new Promise((resolve, reject) => {
      const storageRef = ref(
        getStorage(fireStore),
        `work_samples/$ {file.name}`,
      );
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on(
        "state_changed",
        (snapshot) => { },
        (error) => {
          reject(error);
        },
        async () => {
          const url = await getDownloadURL(uploadTask.snapshot.ref);
          resolve(url);
        },
      );
    });
  };

  const handleSubmit = async (values, actions) => {
    setLoading(true);
    try {
      // Upload all files for each work sample
      const workSamples = await Promise.all(
        values.work_samples.map(async (sample) => {
          const files = await Promise.all(
            sample.files.map(async (fileObj) => {
              const url = await uploadFileToFirebase(fileObj.file);
              return { file: url };
            }),
          );
          return { ...sample, files };
        }),
      );

      // Update the form state with the uploaded file URLs
      const updatedValues = { ...values, work_samples: workSamples };
      setbxpData((prevData) => ({
        ...prevData,
        work_samples: updatedValues.work_samples,
      }));
      // Proceed to the next tab or step
      setActiveTab("PricingTerms");
    } catch (error) {
      // Handle errors gracefully
      urtoast(error.message, 2);
    }
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  const FileUpload = ({ formik, index }) => {
    const { validating, validateFiles } = useFileValidator();

    const onDrop = async (acceptedFiles) => {
      // Manual Size Validation
      const hasLargeFile = acceptedFiles.some(file => file.size > 10 * 1024 * 1024);
      if (hasLargeFile) {
        urtoast("File size exceeds 10 MB limit.", 2);
        return;
      }

      // 🛡️ Validate all files via backend API
      const isValid = await validateFiles(acceptedFiles);
      if (!isValid) return;

      const updatedFiles = acceptedFiles.map((file) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        return new Promise((resolve) => {
          fileReader.onload = () => {
            resolve({ file, preview: fileReader.result });
          };
        });
      });

      Promise.all(updatedFiles).then((newFiles) => {
        formik.setFieldValue(`work_samples[${index}].files`, [
          ...(formik.values.work_samples[index].files || []), // Ensure to handle initial empty state
          ...newFiles,
        ]);
      });
    };

    const { getRootProps, getInputProps } = useDropzone({
      onDrop,
      multiple: true,
    });

    const handleImageError = (e) => {
      // e.target.src = `${CloudStorage.cloudurl}/Assets/Images/expertregisteration/file-upload.png`;
      e.target.src = pdficon;
    };

    return (
      <div className="position-relative">
        {validating && <UploadLoader />}
        <div className="row image-row">
          {formik.values.work_samples[index].files &&
            formik.values.work_samples[index].files.length > 0 &&
            formik.values.work_samples[index].files.map(
              (fileObj, fileIndex) => (
                <div key={fileIndex} className="col-md-4">
                  <div className="image-container">
                    <img
                      src={fileObj.preview || fileObj.file}
                      className="cover-img w-100"
                      alt="Uploaded"
                      onError={handleImageError}
                    />
                    <button
                      type="button"
                      onClick={() => {
                        const updatedFiles = formik.values.work_samples[
                          index
                        ].files.filter((_, i) => i !== fileIndex);
                        formik.setFieldValue(
                          `work_samples[${index}].files`,
                          updatedFiles,
                        );
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/delete-icon.svg`}
                        alt="Delete"
                      />
                    </button>
                  </div>
                </div>
              ),
            )}
        </div>

        <div
          className="dropzone-placeholder"
          {...getRootProps({ className: "borderstylex dropzone" })}
        >
          <input {...getInputProps()} />
          Drag and drop or <span> Browse files</span>
        </div>
        <ErrorMessage
          name={`work_samples[${index}].files`}
          component="div"
          className="error"
        />
      </div>
    );
  };

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {(formik) => (
          <Form>
            <div>
              <h1 className="add-work">
                {updateindex !== null ? "Edit" : "Add"} work sample
              </h1>
              <FieldArray name="work_samples">
                {({ push, remove }) => (
                  <>
                    {formik.values.work_samples.map((sample, index) => (
                      <div key={index} className="work-sample">
                        {bxpDatatomap.map((prop, key) => {
                          if (prop.name == "files") {
                            return (
                              <div key={key} className="form-group">
                                <h6 className="skill-right file-attachment">
                                  {prop.title} <span>(Upload at least 1 file)</span> <sup>*</sup>
                                </h6>
                                <FileUpload formik={formik} index={index} />
                                <ul className="border-ul">
                                  <li>
                                    Images (JPG, PNG, JPEG up to 10MB, No more
                                    than 2000px)
                                  </li>
                                  <li>Documents (PDF, DOCX, XLSX, PPTX, ZIP upto 10MB)</li>
                                </ul>
                              </div>
                            );
                          }
                          return (
                            <FieldInput
                              key={key}
                              title={prop.title}
                              name={`work_samples[${index}].${prop.name}`}
                              placeholder={prop.placeholder}
                            />
                          );
                        })}
                        {formik.values.work_samples.length > 1 && (
                          <div className="remove-sample">
                            <button
                              type="button"
                              className="btn"
                              onClick={() => remove(index)}
                            >
                              Remove Sample
                            </button>
                          </div>
                        )}
                      </div>
                    ))}
                    <div className="button-sample">
                      <button
                        type="button"
                        className="btn"
                        onClick={() => push({ title: "", url: "", files: [] })}
                      >
                        Add More Sample
                      </button>
                    </div>
                  </>
                )}
              </FieldArray>
              <div className="button-container">
                <div
                  style={loading ? disabledStyle : {}}
                  type="button"
                  className="prev-button btn w-100"
                  onClick={() => setActiveTab("BXPDetails")}
                >
                  Back
                </div>
                <div
                  className="next-button btn w-100"
                  type="submit"
                  onClick={formik.handleSubmit}
                >
                  {loading ? <LoginLoaderButton /> : "Next"}
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default WorkSamples;
